:host 
  display: block
  width: fit-content
  margin: 0.5rem auto
  padding: 0.5rem 2rem
  border-radius: 0.2rem

